





































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Language from "@/models/language/language.model";
import TipoEvaluacion from '@/models/evaluacion/tipoEvaluacion.model';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import BaseSelectComponent from '@/components/base/baseSelect/baseSelect.vue';
import PreguntaOpcionRespuesta from '@/models/evaluacion/pregunta-opcion-respuesta';
import { AnswerType } from '@/enums/AsnwerType';
import Pregunta from '../../../models/evaluacion/pregunta.model';

@Component({
  components: {
    BaseSelectComponent
  }
})
export default class EvaluationTypeEdit extends GenericEdit<Pregunta> {
  opcionesRespuesta = [];
  preguntaOpcionRespuestaModel: PreguntaOpcionRespuesta = new PreguntaOpcionRespuesta();
  opcionRespuestaSelected: any = null;
  answerType = AnswerType;
  types = [
    {
      id: AnswerType.TEXTBOX,
      name: 'Comentario'
    },
    {
      id: AnswerType.CHECKBOX,
      name: 'Selección multiple'
    },
    {
      id: AnswerType.SELECT,
      name: 'Selección única'
    },
  ];

  constructor() {
    super();
    this.controller = "Pregunta";
    this.model = new Pregunta();
  } 
    
  addOpcionRespuesta() {
    let preguntaModel: PreguntaOpcionRespuesta = new PreguntaOpcionRespuesta();
    preguntaModel.tipoRespuesta = this.opcionRespuestaSelected;
    preguntaModel.valorString = this.preguntaOpcionRespuestaModel.valorString;
    this.model.preguntaOpcionRespuestas.push(preguntaModel);
    this.preguntaOpcionRespuestaModel.valorString = null;
  } 

  removeAsnwer(data: any) {
    this.model.preguntaOpcionRespuestas.forEach(respuesta => {
      if (data.id == 0) {
        this.model.preguntaOpcionRespuestas = this.model.preguntaOpcionRespuestas.filter(x => x.id != data.id && x.valorString != data.valorString);
      } else if (respuesta.id == data.id) 
        respuesta.deleted = true;
    });
  }

}
